// вынесено отдельно, чтобы в одном месте проверять типизацию ttl
// на случай, если поменяется логика, и оно станет опциональным
// или ноль станет означать нечто другое
export const isExpirationEnabled = (ttlMs: number | null | undefined): boolean => {
    return !!ttlMs; // любое число + больше нуля
};
